import { Fragment, useEffect, useState } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Alert,
  FormControl,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// API
import { getSampleCSV } from "../api/presignedURL";

interface PostCSVModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  postCSVStatus: {
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  };
  setPostCSVStatus: (status: {
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }) => void;
  postCSVFunc: (postDatas: File) => void;
  postCSVTitle: string;
  postCSVColumn: string[];
  postCSVColumnResult: string[];
  postCSVPath: string;
  productList: {
    id: number;
    high_rank_company_id: number;
    product_name: string;
    high_rank_company_name: string;
  }[];
  categoryList: { id: number; category_name: string }[];
}

export function PostCSVModal(props: PostCSVModalProps) {
  const {
    onModal,
    swCloseModal,
    postCSVStatus,
    setPostCSVStatus,
    postCSVFunc,
    postCSVTitle,
    postCSVColumn,
    postCSVColumnResult,
    postCSVPath,
    productList,
    categoryList,
  } = props;
  async function handleFileChange(
    event_file: React.ChangeEvent<HTMLInputElement>
  ) {
    if (event_file.target.files && event_file.target.files.length > 0) {
      const file = event_file.target.files[0];
      postCSVFunc(file);
    }
    // ファイル入力の値をリセットする
    event_file.target.files = null;
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [postCSVProductID, setPostCSVProductID] = useState<number | null>(null);
  const [postCSVProductName, setPostCSVProductName] = useState<string>("");
  const autocompleteProductList: string[] = productList.map((product) => {
    return product.high_rank_company_name === "-"
      ? product.product_name
      : product.high_rank_company_name + "/" + product.product_name;
  });
  useEffect(() => {
    let productID: null | number = null;
    productList.map((product) => {
      const _postCSVProductName =
        product.high_rank_company_name === "-"
          ? product.product_name
          : product.high_rank_company_name + "/" + product.product_name;
      if (postCSVProductName === _postCSVProductName) {
        productID = product.id;
      }
    });
    setPostCSVProductID(productID);
  }, [postCSVProductName]);

  const [postCSVCategoryID, setPostCSVCategoryID] = useState<number | null>(
    null
  );

  async function downloadSampleCSV() {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "loading",
    });
    const product = productList.filter(
      (_product) => _product.id == postCSVProductID
    );
    const productName = product.length > 0 ? product[0].product_name : null;
    const category = categoryList.filter(
      (_category) => _category.id == postCSVCategoryID
    );
    const categoryName = category.length > 0 ? category[0].category_name : null;
    const header_location = await getSampleCSV(
      postCSVPath,
      postCSVProductID,
      productName,
      postCSVCategoryID,
      categoryName
    );
    if (header_location != "None") {
      const url = header_location;
      const link = document.createElement("a");
      link.href = header_location;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
    }
    setPostCSVStatus({
      ...postCSVStatus,
      status: "open",
    });
  }

  async function downloadErrorList() {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "loading",
    });
    const header_location = postCSVStatus.header_location;
    if (header_location != "None") {
      const url = header_location;
      const link = document.createElement("a");
      link.href = header_location;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
    }
    setPostCSVStatus({
      ...postCSVStatus,
      status: "result",
    });
  }

  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="post-csv-modal">
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {postCSVTitle}
        </Typography>
        {postCSVStatus.status === "open" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ marginTop: "15px" }}>
              ※以下CSV項目を使用してください。
            </Box>
            <Box sx={{ marginTop: "5px" }}>
              {`「${postCSVColumn.join("、")}」`}
            </Box>
            {postCSVPath == "addContract" || postCSVPath == "entryContract" ? (
              <Box
                key={"csvContractProduct"}
                sx={{ margin: "10px 20px", display: "flex" }}
              >
                <Box sx={{ width: "100px", marginTop: "2px" }}>商材</Box>
                <Autocomplete
                  sx={{
                    height: "30px",
                    textAlign: "end",
                    width: "calc(100% - 100px)",
                  }}
                  clearIcon={null}
                  options={autocompleteProductList}
                  value={postCSVProductName}
                  onChange={(event: any, newValue: string | null) => {
                    if (newValue) {
                      setPostCSVProductName(newValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      value={postCSVProductName}
                      sx={{
                        "& .MuiInputBase-root": {
                          fontSize: "16px",
                          height: "32px",
                        },
                      }}
                      {...params}
                    />
                  )}
                />
              </Box>
            ) : null}
            {postCSVPath == "tossUp" || postCSVPath == "tossUpAdmin" ? (
              <Box
                key={"csvContractCategory"}
                sx={{ margin: "10px 20px", display: "flex" }}
              >
                <Box sx={{ width: "100px", marginTop: "2px" }}>カテゴリ</Box>
                <Select
                  labelId="serch-input-label"
                  id="serch-input"
                  value={postCSVCategoryID}
                  onChange={(e) => {
                    setPostCSVCategoryID(e.target.value as number);
                  }}
                  sx={{
                    height: "30px",
                    textAlign: "end",
                    width: "calc(100% - 100px)",
                  }}
                >
                  {categoryList.map((category, i) => {
                    return (
                      <MenuItem
                        key={"category" + i}
                        value={category.id}
                        sx={{ textAlign: "right" }}
                      >
                        {category.category_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Box>
            ) : null}
            <Box>
              <Button
                disabled={
                  (postCSVPath == "addContract" ||
                    postCSVPath == "entryContract") &&
                  postCSVProductID == null
                    ? true
                    : (postCSVPath == "tossUp" ||
                        postCSVPath == "tossUpAdmin") &&
                      postCSVCategoryID == null
                    ? true
                    : false
                }
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "405px",
                  width: "190px",
                  fontSize: "20px",
                }}
                component="span"
                onClick={downloadSampleCSV}
                data-testid="post-csv-sample-download"
              >
                サンプルCSV
                <FileDownloadIcon
                  sx={{ marginTop: "-2.5px", marginLeft: "6px" }}
                  fontSize="medium"
                />
              </Button>
              <input
                accept=".csv"
                style={{ display: "none" }}
                id="raised-button-file"
                type="file"
                onChange={(e) => handleFileChange(e)}
              />
              <label htmlFor="raised-button-file">
                <Button
                  variant="outlined"
                  style={{
                    marginTop: "15px",
                    height: "40px",
                    position: "absolute",
                    right: "225px",
                    width: "160px",
                    fontSize: "20px",
                  }}
                  component="span"
                  data-testid="post-csv-upload-button"
                >
                  CSV取込
                  <AttachFileIcon
                    sx={{ marginTop: "-2.5px", marginLeft: "6px" }}
                    fontSize="medium"
                  />
                </Button>
              </label>
              <Button
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "45px",
                  width: "160px",
                  fontSize: "20px",
                }}
                data-testid="post-csv-cancel-button"
                onClick={() => {
                  swCloseModal();
                  setPostCSVProductID(null);
                }}
              >
                キャンセル
              </Button>
            </Box>
          </Typography>
        ) : postCSVStatus.status === "posting" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>{postCSVStatus.message}</Box>
          </Typography>
        ) : postCSVStatus.status === "error" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Alert severity="error">
              <Box>CSVの取込に失敗しました。</Box>
              <Box sx={{ marginTop: "15px" }}>
                ・質問名が異なる可能性があります。
              </Box>
              <Box sx={{ textAlign: "center" }}>{postCSVStatus.message}</Box>
            </Alert>
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              data-testid="post-csv-error-back-button"
              onClick={() => {
                setPostCSVStatus({
                  status: "open",
                  message: "",
                  result: [],
                  header_location: "None",
                });
                setPostCSVProductID(null);
              }}
            >
              戻る
            </Button>
          </Typography>
        ) : postCSVStatus.status === "result" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box>{postCSVStatus.message}</Box>
            {postCSVStatus.result.length > 0 ? (
              <Box sx={{ marginTop: "15px" }}>
                <Alert severity="error">
                  ※以下データ登録時にエラーが発生しました。
                </Alert>

                <TableContainer
                  component={Paper}
                  sx={{
                    margin: "1px 1px",
                    width: "calc(100% - 4px)",
                    maxHeight: "calc(70vh - 180px)",
                    border: "1px solid rgb(230, 230, 230)",
                  }}
                >
                  <Table
                    stickyHeader
                    size="small"
                    aria-label="collapsible table"
                  >
                    <TableHead>
                      <TableRow key="errorCSVTableRow">
                        <TableCell key={"errorCSVTableMessage"} align="center">
                          エラーメッセージ
                        </TableCell>
                        {postCSVColumnResult.map((column, i) => {
                          return (
                            <TableCell
                              key={"errorCSVTableColumn" + i}
                              align="center"
                            >
                              {column}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {postCSVStatus.result.map((result, i) => (
                        <Fragment key={"errorCSVTableFragment" + i}>
                          <TableRow>
                            <TableCell
                              key={"errorCSVTableCell" + i}
                              align="center"
                            >
                              {result.message}
                            </TableCell>
                            {postCSVColumnResult.map((column, column_i) => {
                              return (
                                <TableCell
                                  key={
                                    "errorCSVTableColumn" +
                                    i +
                                    "Data" +
                                    column_i
                                  }
                                  align="center"
                                >
                                  {result.postData[column]}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : null}
            {postCSVStatus.header_location != "None" ? (
              <Button
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "220px",
                  width: "280px",
                  fontSize: "20px",
                }}
                onClick={downloadErrorList}
                data-testid="post-csv-error-download"
              >
                エラー内容ダウンロード
              </Button>
            ) : null}
            <Button
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              data-testid="post-csv-result-close-button"
              onClick={() => {
                swCloseModal();
                setPostCSVProductID(null);
              }}
            >
              閉じる
            </Button>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
}
